module.exports = __webpack_public_path__ + "assets/GoldDelta.6e63d7c729e1c677bf467bfbaa87d77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldDelta.png
// module id = 759
// module chunks = 0